import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class SidebarInternalService {
  public sidebarMinimized: BehaviorSubject<boolean | null> = new BehaviorSubject(null);
  public sidebarMinimized$: Observable<boolean> = <Observable<boolean>>(
    this.sidebarMinimized.asObservable().pipe(filter(value => value != null))
  );
}
